import React from 'react';
import { Modal } from 'antd';
import styled from 'styled-components';
import { backgroundColorParsing } from 'Utils/UtilityFunctions';
import { PersonalityTypes } from 'Types/PersonTypes';
import { GetPersonProfileRequest } from 'Types/RequestBodies';
import { actions as personProfileActions } from 'Slice/PersonProfileSlice';
import { useDispatch } from 'react-redux';
import PeopleWidget from 'Components/common/components/PeopleWidget';

type Props = {
  persona: string;
  logo: string;
  personName: string;
  personDesignation: string;
  personalityTypes: PersonalityTypes[];
  visible: boolean
  personId: number
  profileId: number
  togglePopup: (bool: boolean) => void
};
const Wrapper = styled.div`
`;

const ProfileWrapper = styled.div`
 display: flex;
 flex-direction: column;
 align-items: center;
 padding: 30px 0px 0px 0px;

`;

const AffinitySearchPopup = function AffinitySearchPopup(props: Props) {
  const {
    logo, persona, personName, personDesignation, visible, personalityTypes, personId,
    profileId, togglePopup,
  } = props;
  const dispatch = useDispatch();
  const onClickCancel = () => {
    togglePopup(false);
  };
  const onClickOk = () => {
    const data: GetPersonProfileRequest = {
      personId,
      type: 'EXECUTIVE',
      affinity_person: profileId,
      map_personality: 1,
    };
    dispatch(personProfileActions.getSearchedPersonProfileInsights(data));
  };
  return (
    <Wrapper>
      <Modal
        open={visible}
        centered
        width={626}
        closeIcon
        getContainer=""
        wrapClassName="modal-c-widget affinityPopup"

      >
        <span className="the-title">Is this you?</span>
        <ProfileWrapper>
          <PeopleWidget
            disableNavigation
            diameter="150px"
            margin="0px"
            ringPadding="0px"
            ringPaddingSm="0px"
            diameterSm="100px"
            diameterXsm="80px"
            // ringPadding="3px"
            // ringPaddingSm="2px"
            marginSm="0px 5px 0px 0px"
            wrapperColor={backgroundColorParsing(personalityTypes || [])}
            personalityTypesColors={personalityTypes}
            holoDiameterHeight="140px"
            holoDiameterWidth="140px"
            logo={logo}
            persona={persona}
            // hidePersonality={false}
            personId={0}
          // margin="0 10px"
          />
          <span className="name">{personName}</span>
          <span className="designation">{personDesignation}</span>
        </ProfileWrapper>
        <div className="ant-modal-footer custom-footer">
          <span
            tabIndex={0}
            role="button"
            aria-label="yes"
            className="button btn-yes"
            onClick={onClickOk}
            onKeyPress={onClickOk}
          >
            YES
          </span>
          <span
            tabIndex={0}
            role="button"
            aria-label="no"
            className="button btn-no"
            onClick={onClickCancel}
            onKeyPress={onClickCancel}
          >
            NO
          </span>

        </div>
      </Modal>
    </Wrapper>
  );
};

export default AffinitySearchPopup;
